import { normalizeContextPath } from "../layouts/Flow Designer/helpers/common";

const varRegex = /@variables\\.([a-zA-Z0-9-_]+(?:\\.[a-zA-Z0-9-_]+)*)/gi;

const stepRegex = /@steps\\.([a-zA-Z0-9-_]+(?:\\.[a-zA-Z0-9-_]+)*)/gi;

const settingsRegex = /@settings\.([a-zA-Z0-9-_]+(?:\.[a-zA-Z0-9-_]+)*)/gi;

const getValueByPath = (obj, path) => {
	if (!obj || !path) return undefined;

	return path.split(".").reduce((acc, key) => {
		if (acc && typeof acc === "object" && key in acc) {
			return acc[key];
		}
		return undefined;
	}, obj);
};

export const replaceStringContextValue = (fieldValue, context) => {
	if (!context || typeof fieldValue !== "string") return fieldValue;

	return fieldValue
		.replace(varRegex, (match) => {
			const normalizedPath = normalizeContextPath(match);
			const value = getValueByPath(context, normalizedPath);

			if (value === undefined) return match;

			return typeof value === "object"
				? JSON.stringify(value)
				: String(value);
		})
		.replace(stepRegex, (match) => {
			const normalizedPath = normalizeContextPath(match);
			const value = getValueByPath(context, normalizedPath);
			return value === undefined ? match : String(value);
		})
		.replace(settingsRegex, (match) => {
			const normalizedPath = normalizeContextPath(match);
			const value = getValueByPath(context, normalizedPath);
			return value === undefined ? match : String(value);
		});
};
